import Controller from "@ember/controller"
import { action, get } from "@ember/object"
import PromiseProxyMixin from "@ember/object/promise-proxy-mixin"
import ObjectProxy from "@ember/object/proxy"
import { inject as service } from "@ember/service"

class ObjectPromiseProxy extends ObjectProxy.extend(PromiseProxyMixin) {}

export default class VersionController extends Controller {
  @service
  rpc

  @action
  rollBack(id) {
    get(this, "rpc")["ROLLBACK"](id)
  }
}
